import { Text, Thumbnail } from '@wix/design-system';
import { useIsMobile } from 'hooks/useIsMobile';
import React, { FC } from 'react';
import { SelectableProduct } from 'types/selectable-product';
import styles from '../SelectProductsStep.scss';

const SKELETON_ITEM_COUNT = 8;

interface ProductPickerGridProps {
  products: SelectableProduct[];
  selectedProductIds: string[];
  onToggle: (product: SelectableProduct) => void;
  maxSelectedProducts: number;
  isLoading?: boolean;
}

export const ProductPickerGrid: FC<ProductPickerGridProps> = ({
  products,
  selectedProductIds,
  onToggle,
  maxSelectedProducts,
  isLoading = false,
}) => {
  const isMobile = useIsMobile();

  if (isLoading) {
    return (
      <div className={styles.selectProductsStepOptions} aria-busy="true" aria-live="polite">
        {[...Array.from({ length: SKELETON_ITEM_COUNT })].map((_, index) => (
          <div key={index} className={styles.selectProductsStepOptionsItem}>
            <div className={styles.selectProductsStepOptionsItemSkeleton} />
            <div className={styles.selectProductsStepOptionsItemLabel}>
              <div className={styles.selectProductsStepOptionsItemLabelSkeleton} />
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.selectProductsStepOptions}>
      {products.map((product) => {
        const isSelected = selectedProductIds.includes(product.id);
        const image = isSelected && isMobile ? product.mockupImageUrl : product.imageUrl;

        return (
          <div key={product.id} className={styles.selectProductsStepOptionsItem}>
            <Thumbnail
              disabled={selectedProductIds.length >= maxSelectedProducts && !isSelected}
              onClick={() => onToggle(product)}
              selected={isSelected}
            >
              <img src={image} alt={product.name} className={styles.selectProductsStepOptionsItemImage} />
            </Thumbnail>
            <div className={styles.selectProductsStepOptionsItemLabel}>
              <Text ellipsis size="small" weight="normal" maxLines={3}>
                {product.name}
              </Text>
            </div>
          </div>
        );
      })}
    </div>
  );
};
